/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import LoaderContainer from './loader-container';

import template from './loader-root.html';

export default {
  name: 'LoaderRoot',
  template,
  components: { LoaderContainer }
};
